import { Role } from '@/core/components/auth/auth.types'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { promoCodeQueryOptions } from '@/core/components/sites/site/rates-and-packages/promo-code/promoCodeQueryOptions'
import { cancellationPoliciesQueryOptions } from '@/core/components/sites/site/site-customization/policies/policiesQueryOptions'
import { taxAndFeesPoliciesQueryOptions } from '@/core/components/sites/site/site-customization/policies/taxAndFeesQueryOptions'
import { defer, redirect } from '@tanstack/react-router'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_layout/dashboard/sites/$siteId/activities-and-products/create/'
)({
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (
      auth.user?.role === Role['Front-Desk'] ||
      auth.user?.role === Role['Blogger']
    ) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  loader: ({ context: { queryClient, auth }, params: { siteId } }) => {
    const taxes = defer(
      queryClient.ensureQueryData(
        taxAndFeesPoliciesQueryOptions(siteId, auth.token!)
      )
    )
    const cancelation = defer(
      queryClient.ensureQueryData(
        cancellationPoliciesQueryOptions(siteId, auth.token!)
      )
    )
    const promoCodes = defer(
      queryClient.ensureQueryData(promoCodeQueryOptions(siteId, auth.token!))
    )

    return {
      taxes,
      cancelation,
      promoCodes,
    }
  },
  pendingComponent: LoadingList,
  errorComponent: ErrorComponent,
})
